import "slick-carousel/slick/slick";
import Parallax from "parallax-js";
import Accordion from "@/modules/containers/accordion";
import {
  initLoader,
  hideLoader
} from "@/modules/loader/loader";
import video from "@/modules/accessability-exp-10743/video/video";
import howToSignBlock from "@/modules/how-to-sign/index";
import { CLASSES } from "@/scripts/helpers/constants";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import { checkWebpSupport } from "@/scripts/helpers/library";
import lazyframe from "lazyframe";
import productSlider from "@/modules/product-block/index";
import { each } from "lodash";
import modalShow from "@/modules/containers/modal/modal";
import select2 from "select2";

const videoClass = ".js-ready-video";
let videoWasPlayedFlag = false;
const mediaScreenTablet = 640;

const initParallaxDecorations = () => {
  const scene = $(".js-decorations-key-features-group");
  const sceneFaq = $(".js-decorations-faq-group");

  if (scene.length) {
    const parallaxInstance = new Parallax(scene[0], {
      pointerEvents: false,
      invertX: false,
      invertY: false,
      relativeInput: false
    });
    parallaxInstance.friction(0.2, 0.2);
  };

  if (sceneFaq.length) {
    const parallaxInstanceFaq = new Parallax(sceneFaq[0], {
      pointerEvents: false,
      invertX: false,
      invertY: false,
      relativeInput: false
    });
    parallaxInstanceFaq.friction(0.2, 0.2);
  };
};

const inView = function (element) {
  const win = $(window);
  const obj = element;
  const scrollPosition = win.scrollTop();
  const visibleArea = win.scrollTop() + win.height();
  const objEndPos = obj.offset().top;

  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

const loadVideo = () => {
  const lazyVideos = [].slice.call(document.querySelectorAll(videoClass));

  lazyVideos.forEach(function (lazyVideo) {
    lazyVideo.children[0].src = lazyVideo.children[0].dataset.src;
    lazyVideo.load();
  });
};

const playVideo = () => {
  const video = document.querySelector(videoClass);

  if (video !== null) {
    loadVideo();

    window.addEventListener("scroll", event => {
      if (!videoWasPlayedFlag && inView($(video))) {
        video.play();
        videoWasPlayedFlag = true;
      }
    });
  }
};

const handleFullscreenHelpers = () => {
  const header = $(".layout-responsive__header, .feature-teasers-list");
  const chat = $(".sv-chat-wrapper");
  const bannerHeader = $(".banner-header");
  const sliderNav = $(".efficiency-slider--accessibility .efficiency-slider__nav");
  const sectionIntro = $(".page-section--intro");
  const sectionBusinessCloud = $(".page-section--business-cloud");
  const sliderNavList = $(".efficiency-slider-control")
  if (
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement
  ) {
    if (header.length) header.addClass("is-hidden")
    if (chat.length) chat.addClass("is-hidden opacity-0 not-visible")
    if (bannerHeader.length) bannerHeader.addClass("is-hidden")
    if (sliderNav.length) sliderNav.addClass("is-hidden opacity-0")
    if (sliderNavList.length) sliderNavList.addClass("is-hidden opacity-0")
    if (sectionIntro.length) sectionIntro.addClass("is-hidden")
    if (sectionBusinessCloud.length) sectionBusinessCloud.addClass("is-hidden")
  } else {
    header.removeClass("is-hidden");
    chat.removeClass("is-hidden opacity-0 not-visible");
    bannerHeader.removeClass("is-hidden");
    sliderNav.removeClass("is-hidden opacity-0");
    sliderNavList.removeClass("is-hidden opacity-0");
    sectionIntro.removeClass("is-hidden");
    sectionBusinessCloud.removeClass("is-hidden");
  }
}

const initSliderKeyFeatures = () => {
  if ($(".efficiency-slider").hasClass("efficiency-slider--experiment")) {
    $(".efficiency-slider__nav-item--01").remove();
    $("#efficiency-slide-01").remove();
  } else {
    $(".efficiency-slider__nav-item--0").remove();
    $("#efficiency-slide-1").remove();
  }

  $(".js-slider-key-features-navigation").on("init", function () {
    $(this).find(".slick-slide").removeAttr("aria-hidden");
  });

  $(".js-efficiency-slider-nav").on("init", function () {
    $(this).find(".slick-slide").removeAttr("aria-hidden");
  });

  $(".js-slider-key-features-viewport").on("init", function () {
    $(".slider-key-features").addClass("is-visible");
    $(this).find(".slick-slide").removeAttr("aria-hidden");
  });

  $(".js-partners-logos-carousel").on("init", function () {
    $(".js-partners-logos-carousel").addClass("is-visible");
  });

  $(".js-efficiency-slider-viewport").on("init", function () {
    $(".js-efficiency-slider-viewport").addClass("is-visible");
    $(this).find(".slick-slide").removeAttr("aria-hidden");
    $(this).find(".slick-list").attr("aria-live", "polite");
  });

  $(".how-to-sign-slider").on("init", function () {
    $(".how-to-sign-slider").addClass("is-visible");
  });


  $(".js-slider-key-features-viewport").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: false,
    fade: true,
    cssEase: "linear",
    speed: 150,
    focusOnSelect: true,
    dots: false,
    accessibility: false,
    asNavFor: ".js-slider-key-features-navigation"
  });

  $(".js-slider-key-features-navigation").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".js-slider-key-features-viewport",
    draggable: false,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    accessibility: false,
    responsive: [{
      breakpoint: 639,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        arrows: false,
        dots: false,
        infinite: false
      }
    }]
  });
  let $slickSlider = false;

  $(".slider-key-features__navigation-item").on("focusin", function (event) {
    let slideIndex = $(this).attr("data-slide-index")
    let sliderNavigation = $(".js-slider-key-features-navigation")
    let sliderViewport = $(".js-slider-key-features-viewport")
    sliderNavigation[0].slick.slickGoTo(parseInt(slideIndex));
    sliderViewport[0].slick.slickGoTo(parseInt(slideIndex));
    $(".key-feature__action").attr("tabindex", "0");
    $(".js-slider-key-features-navigation").find(".slick-slide").removeAttr("aria-hidden");
    $(".slider-key-features__navigation-item").find(".accessibility-hidden-content").text("not selected");
    $(this).find(".accessibility-hidden-content").text("selected");
  });

  $(".js-efficiency-slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".js-efficiency-slider-viewport",
    draggable: false,
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    accessibility: false,
    pauseOnHover: true,
    pauseOnFocus: true,
    pauseOnDotsHover: !(!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)),
    responsive: [{
      breakpoint: 639,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: true,
        arrows: false,
        dots: false,
        infinite: false
      }
    }]
  });

  $(".js-efficiency-slider-nav, .js-efficiency-slider-viewport").on('afterChange', function () {
    $(".js-efficiency-slider-nav").find(".slick-slide").removeAttr("aria-hidden");
  });

  $(".js-efficiency-slider-viewport").on("afterChange", function(event, slick, currentSlide, nextSlide){
    $(".js-efficiency-slider-viewport .slick-slide").attr("aria-label", "Not selected")
    $(".js-efficiency-slider-viewport .slick-slide").eq(currentSlide).attr("aria-label", "Selected")
  });


  setTimeout(() => {
    $(".js-efficiency-slider-viewport .slick-slide").attr("aria-label", "Not selected")
    $(".js-efficiency-slider-viewport .slick-slide").eq(0).attr("aria-label", "Selected")
  }, 10);

  const slickSliderBenefits = () => {
    $(".js-efficiency-slider-viewport")
      .not(".slick-initialized")
      .slick({
        dots: false,
        arrows: false,
        fade: true,
        cssEase: "linear",
        speed: 150,
        autoplaySpeed: 4000,
        autoplay: true,
        infinite: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        accessibility: false,
        focusOnSelect: true,
        pauseOnDotsHover: !(
          !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        ),
        responsive: [{
          breakpoint: 640,
          settings: "unslick"
        }]
      });
  };

  $(".efficiency-slider__nav-item").on("click focusin", function (event) {
    let slideIndex = $(this).attr("data-slide-index")
    let sliderNavigation = $(".js-efficiency-slider-nav")
    let sliderViewport = $(".js-efficiency-slider-viewport")
    sliderNavigation[0].slick.slickGoTo(parseInt(slideIndex));
    sliderViewport[0].slick.slickGoTo(parseInt(slideIndex));
    $(".js-efficiency-slider-nav").find(".slick-slide").removeAttr("aria-hidden");
    $(".efficiency-slider__nav-item").find(".accessibility-hidden-content").text("not selected");
    $(this).find(".accessibility-hidden-content").text("selected");
  });

  $(".efficiency-slider__nav-item").on("keyup", function (e) {
    if (e.which == 9) {
      $(".efficiency-slider__nav-item").not(e.currentTarget).removeClass("focused");
      $(this).addClass("focused")
    }
  });

  $(".efficiency-slider__nav-item:last-child").on("keydown keypress", function (e) {
    if (e.which == 9) {
      $(this).removeClass("focused")
    }
  });

  function slickSliderPartners() {
    if ($(window).width() > 639) {
      if (!$slickSlider) {
        $(".js-partners-logos-carousel")
          .slick({
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            variableWidth: true,
            draggable: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            autoSlidesToShow: true
          })
          .on("beforeChange", function (e, slick) {
            const width = $(
              ".js-partners-logos-carousel .slick-current"
            ).outerWidth();
            const speed = (width * 6000) / 200;

            $(".js-partners-logos-carousel").slick("setOption", "speed", speed);
          });
        $slickSlider = true;
      }
    } else if ($(window).width() < 638) {
      if ($slickSlider) {
        $(".js-partners-logos-carousel").slick("unslick");
        $slickSlider = false;
      }
    }
  }

  slickSliderBenefits();
  slickSliderPartners();

  $(window).on("resize", function () {
    let mediaScreenDesktop = 960;

    if ($(window).width() > mediaScreenDesktop) {
      slickSliderBenefits();
    }
  });

  let sliderIsHidden = true;

  $(window).scroll(function () {
    const element = document.querySelector(".efficiency-slider");
    const position = element.getBoundingClientRect();

    if (
      position.top < window.innerHeight &&
      position.bottom >= 0 &&
      sliderIsHidden
    ) {
      $(".js-efficiency-slider-viewport").slick("slickGoTo", 0, true);
      sliderIsHidden = false;
    }
  });

  $(".js-efficiency-slider-viewport .slick-dots li").on(
    "mouseover click touch touchstart",
    function () {
      $(".js-efficiency-slider-viewport .slick-dots li").removeClass("filled");
      $(this).addClass("filled");
      $(".js-efficiency-slider-viewport").slick("goTo", $(this).index());
    }
  );

  $(".js-efficiency-slider-viewport").on("beforeChange", function (
    e,
    slick,
    currentSlide,
    nextSlide
  ) {
    if (nextSlide) {
      $(".js-efficiency-slider-viewport .slick-dots li").removeClass("filled");
    }
  });
};

const sendMyDocument = () => {
  $(".js-send-my-document").on("click", function (event) {
    event.preventDefault();
    $(event.target).siblings().focus().trigger("click");
  });

  $(".js-send-my-document-button").on("click keyup", function (event) {
    if (event.keyCode === 13) {
      $("#sendMyDocument").focus().trigger("click");
    }
  });

  $(".js-sign-my-document-button").on("keyup", function (event) {
    if (event.keyCode === 13) {
      $("#signMyDocument").focus().trigger("click");
    }
  });

  $("#sendMyDocument").change(function () {
    $("#sendMyDocumentForm").submit();
    initLoader($(".loader"));
  });

  $("#signMyDocument").change(function () {
    $("#signMyDocumentForm").submit();
    initLoader($(".loader"));
  });
};

const starResourceReview = () => {
  $(".js-resource-review").each(function () {
    const dataRating = $(this).data().rating;
    const element = $(this).find(".filling");
    const fullCount = Math.floor(dataRating);
    const partCount = Math.ceil((dataRating - fullCount) * 100) / 100;
    const fullStar = 16;
    const gap = 2;
    const fill = fullCount * (fullStar + gap) + partCount * fullStar;
    element.attr("width", fill);
  });

  //- exp-11026
  $(".js-resources-with-reviews").each(function () {
    const dataRating = $(this).data().rating;
    const element = $(this).find(".filling");
    const fullCount = Math.floor(dataRating);
    const partCount = Math.ceil((dataRating - fullCount) * 100) / 100;
    const fullStar = 14.8;
    const gap = 2;
    const fill = fullCount * (fullStar + gap) + partCount * fullStar;
    element.attr("width", fill);
  });
};

const showMoreAccordionItems = () => {
  const cardsList = $(".page-section--faq .accordion"),
    cardsItem = $(".page-section--faq .accordion__item"),
    showMoreBtn = $(".js-accordion-show-more"),
    showLessBtn = $(".js-accordion-show-less");

  if (cardsList.length) {
    cardsList.ready(function () {
      let i = 0;

      cardsItem.each(function () {
        i += 1;

        if (i > 10) {
          $(this).addClass(CLASSES.IS_HIDDEN);
        }
      });

      if (cardsItem.length <= 10) {
        showMoreBtn.addClass(CLASSES.IS_HIDDEN);
      };

      showMoreBtn.on("click keydown", function (e) {
        if (e.which === 13 || e.keyCode === 13 || e.type === "click") {
          e.stopPropagation();
          e.preventDefault()
          let i = 0;

          $(this).parents(".accordion__title").blur();

          $(".page-section--faq .accordion__item.is-hidden").each(function () {
            if ($(this).length <= 12) {
              $(this).removeClass(CLASSES.IS_HIDDEN);
              $(this).addClass(CLASSES.IS_VISIBLE);
            }
          });

          const cardsItemHidden = $(".page-section--faq .accordion__item.is-hidden");

          if (cardsItemHidden.length < 1) {
            showMoreBtn.addClass(CLASSES.IS_HIDDEN);
            showLessBtn.removeClass(CLASSES.IS_HIDDEN);
          }
        }
      });
    });
    showLessBtn.on("click keydown", function (e) {
      if (e.which === 13 || e.keyCode === 13 || e.type === "click") {
        e.stopPropagation();
        e.preventDefault();
        let i = 0;

        cardsItem.each(function () {
          i += 1;
          if (i <= 10) {
            $(".page-section--faq .accordion__item:not(:lt(" + 10 + "))").addClass(CLASSES.IS_HIDDEN);
            cardsItem.removeClass(CLASSES.IS_VISIBLE);
          }

          showMoreBtn.removeClass(CLASSES.IS_HIDDEN);
          showLessBtn.addClass(CLASSES.IS_HIDDEN);
          $("html, body").animate({
            scrollTop: $(".js-accordion-show-more").offset().top - 140
          }, 1000);
          return false;
        });
      }
    });
  };
  cardsItem.on("focusin", function () {
    if ($(this).find(".accordion__show-button").length) {
      $(this).find(".accordion__show-button").attr("tabindex", "0")
    }
  });
}

const addKeyboardListener = () => {
  $(".js-partners-link").focus(function() {
    $(".partners-logos-carousel-wrapper").addClass("focused");
  });
  $(".js-partners-link").on("keydown", function (event) {
    if (event.which === 9 || event.keyCode === 9) {
      $(".partners-logos-carousel-wrapper").removeClass("focused");
    }
  });
}

const efficiencySliderNavigation = () => {
  const efficiencySliderControlItem = $(".efficiency-slider-control__item");
  const efficiencySlider = $(".js-efficiency-slider-viewport");
  const efficiencyLink = $(".js-efficiency-link");
  const videoButton = $(".video-player__play-button");
  const efficiencySliderControlButton = $(".efficiency-slider-control__button");

  efficiencySlider.on("beforeChange", function(event, slick, currentSlide, nextSlide) {
    efficiencySliderControlItem.removeClass(CLASSES.IS_ACTIVE);
    efficiencySliderControlItem.eq(nextSlide).addClass(CLASSES.IS_ACTIVE);
  })

  efficiencySlider.on("afterChange", function(event, slick, currentSlide, nextSlide){
    $(".efficiency-slider-control__button .accessibility-hidden-content").text("not selected");
    efficiencySliderControlItem.eq(currentSlide)
    .children(".efficiency-slider-control__button")
    .find(".accessibility-hidden-content")
    .text("selected");
  })

  efficiencySliderControlButton.on("click keyup", function(event) {
    const slideIndex = $(this).parent().index();
    efficiencySlider.slick("slickGoTo", slideIndex);
    if (event.which === 9 || event.keyCode === 9) {
      efficiencySlider.slick("slickPause");
      setTimeout(() => {
        efficiencySlider.slick("slickPlay");
      }, 10000);
    }
    if (event.shiftKey && event.keyCode === 9) {
      videoButton.attr("tabindex", "0");
    }
  });

  videoButton.on("keydown", function(event) {
    if ((event.which === 9 || event.keyCode === 9) && !(event.shiftKey && event.keyCode === 9)) {
      setTimeout(() => {
        $(".efficiency-slider-control__item:eq(1)").children(".efficiency-slider-control__button").focus();
        efficiencySliderControlButton.removeAttr("tabindex");
      }, 10);
    }
  });

  $(".efficiency-slider-control__item:eq(0)").children(".efficiency-slider-control__button").on("keydown", function(event) {
    if ((event.which === 9 || event.keyCode === 9) && !(event.shiftKey && event.keyCode === 9)) {
      setTimeout(() => {
      videoButton.focus();
      efficiencySliderControlButton.attr("tabindex", "-1");
      }, 10);
    }
  });

  $(".efficiency-slider-control__item:eq(2)").children(".efficiency-slider-control__button").on("keydown", function(event) {
    if ((event.which === 9 || event.keyCode === 9) && !(event.shiftKey && event.keyCode === 9)) {
      setTimeout(() => {
      efficiencyLink.focus();
      efficiencySliderControlButton.attr("tabindex", "-1");
      }, 10);
    }
  });

  efficiencyLink.on("keydown", function(event) {
    if ((event.which === 9 || event.keyCode === 9) && !(event.shiftKey && event.keyCode === 9)) {
      setTimeout(() => {
        $(".efficiency-slider-control__item:eq(3)").children(".efficiency-slider-control__button").focus();
        efficiencySliderControlButton.removeAttr("tabindex");
        videoButton.removeAttr("tabindex");
      }, 10);
    }
  });
}

const reviewSlider = () => {
  const nextArrow = $(".review-slider-navigation__arrow--next"),
        prevArrow = $(".review-slider-navigation__arrow--prev"),
        slickElement = $(".js-customers-review-slider");

  slickElement.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1,
        mediaScreenDesktop = 960;

    if ($(window).width() > mediaScreenDesktop) {
      var sumCouner = slick.$dots[0].children.length - 1;
    } else {
      var sumCouner = slick.$dots[0].children.length;
    }

    if (counter === 1) {
      prevArrow.addClass(CLASSES.IS_DISABLED);
      prevArrow.attr("tabindex", "-1");
    } else if (counter === sumCouner) {
      nextArrow.addClass(CLASSES.IS_DISABLED);
      nextArrow.attr("tabindex", "-1");
      prevArrow.removeClass(CLASSES.IS_DISABLED);
      prevArrow.removeAttr("tabindex", "-1");
    } else {
      nextArrow.removeClass(CLASSES.IS_DISABLED);
      nextArrow.removeAttr("tabindex", "-1");
      prevArrow.removeClass(CLASSES.IS_DISABLED);
      prevArrow.removeAttr("tabindex", "-1");
    }
  });

  slickElement.slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true,
    autoplay: false,
    arrows: false,
    adaptiveHeight: true,
    speed: 600,
    cssEase: 'ease',
    variableWidth: true,
    swipeToSlide: false,
    swipe: false,
    dots: true,
    responsive: [{
        breakpoint: 959,
        settings: {
          slidesToShow: 2,
          variableWidth: false,
          swipeToSlide: true,
          swipe: true,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
          swipeToSlide: true,
          swipe: true,
          slidesToScroll: 1
        }
      }
    ]
  });

  nextArrow.click(function (e) {
    e.preventDefault();
    slickElement.slick("slickNext");
  });

  prevArrow.click(function (e) {
    e.preventDefault();
    slickElement.slick("slickPrev");
  });
};

const detectDevice = () => {
  const uploaderSection = $(".page-section--feature-teasers");
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
    uploaderSection.addClass(CLASSES.IS_HIDDEN);
  }
};

const customSelect = () => {
  const selectItem = $("#employees");

  selectItem.select2({
    selectOnClose: false,
    minimumResultsForSearch: Infinity
  });

  $(".select2").after($("select#employees"));

  const hideCustomSelectError = event => {
    const parsley = $(event.target).next(".parsley-errors-list");
    if (parsley.length) parsley.remove()
  };

  selectItem.on("select2:open", function (event) {
    hideCustomSelectError(event)
  });
  selectItem.on("select2:close", function (event) {
    hideCustomSelectError(event)
    const selectWrapper = $(".selectric-wrapper.has-error"),
          selectText = $("#select2-employees-container").text(),
          textLabel = "Company size";

    if (selectText != textLabel) selectWrapper.removeClass("has-error");
  });

  const formControl = $(".form-control"),
        selectricWrapper = $(".selectric-wrapper"),
        selectricInput = $(".selectric-wrapper .selectric");

  selectricWrapper.on("keyup", function(e) {
    if (e.keyCode === 9) {
      selectricWrapper.addClass("selectric-above");
    }
  });

  selectricInput.on("click", function() {
    if (selectricWrapper.length) {
      selectricWrapper.addClass("selectric-above");
    }
  });
}

$(document).ready(function () {

  if ($(window).width() > mediaScreenTablet) {

    $(window).resize(handleFullscreenHelpers);

    initWowLibrary();
    initParallaxDecorations();
    initSliderKeyFeatures();
    sendMyDocument();
    efficiencySliderNavigation();
    addKeyboardListener();
    checkWebpSupport();
  }

  playVideo();
  starResourceReview();
  Accordion();
  video();
  howToSignBlock();
  productSlider();
  showMoreAccordionItems();
  addedLazyLoadImages();
  reviewSlider();
  detectDevice();
  customSelect();
  modalShow();
});

window.addEventListener("pagehide", function () {
  if ($(".loader-wrapper").length) {
    hideLoader($(".loader"));
  }
});
